import Vue from 'vue';
import Router from 'vue-router';
import routes from './routers';
import store from '@/store';
import ViewUI from 'iview';
import { canTurnTo, getToken } from '@/libs/util';
import LoginState from '@/libs/loginState';

Vue.use(Router);
const router = new Router({
    routes
    // mode: 'history'
});
const LOGIN_PAGE_NAME = 'login';

router.beforeEach((to, from, next) => {
    ViewUI.LoadingBar.start();
    let token = getToken();
    let loginStateWell = LoginState.checkAllStateWell();
    if (!loginStateWell) {
        // 系统所需的 loginStorage keys 有缺失，需重新登录补全
        token = false;
    }

    if (!token && to.name !== LOGIN_PAGE_NAME) {
        // 未登录且要跳转的页面不是登录页
        next({
            name: LOGIN_PAGE_NAME // 跳转到登录页
        });
    }
    else if (!token && to.name === LOGIN_PAGE_NAME) {
        // 未登陆且要跳转的页面是登录页
        next(); // 跳转
    }
    else if (token && to.name === LOGIN_PAGE_NAME) {
        // 已登录且要跳转的页面是登录页
        next({
            name: 'home' // 跳转到home页
        });
    }
    else {
        // 目前只从store中获取access 不采用接口实时获取
        if (canTurnTo(to.name, store.state.user.access, routes)) {
            next();
        }
        else {
            next({ replace: true, name: 'error_401' });
        }
    }
});

router.afterEach(function () {
    ViewUI.LoadingBar.finish();
    window.scrollTo(0, 0);
});

export default router;
